import { faPlus, faTrash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { TDSNonSalaryDetailsAddManuallyForm } from ".";
import { IFormITR1, INonSalaryTDS } from "../../../config/interfaces";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";
import { ConfirmationModal } from "../../modals";

const TDSNonSalaryDetails: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IFormITR1>();

  // const [showUpload26ASFormCanvas, setShowUpload26ASFormCanvas] = useState<boolean>(false);
  const [showAddFormCanvas, setShowAddFormCanvas] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<INonSalaryTDS | null>(null);
  const [activeItem, setActiveItem] = useState<INonSalaryTDS | null>(null);
  // used in both edit and delete cases
  const [activeItemIdx, setActiveItemIdx] = useState<string>("");

  const NonSalaryTDS = cloneDeep(values.TaxesPaidTDSandTCS?.NonSalaryTDS || []);

  const handleDeleteItem = async () => {
    NonSalaryTDS.splice(Number(activeItemIdx), 1);
    setFieldValue("TaxesPaidTDSandTCS.NonSalaryTDS", NonSalaryTDS);
    setShowDeleteModal(() => null);
    setActiveItem(() => null);
    setActiveItemIdx(() => "");
    handleTotalCalculation();
  };

  const handleTotalCalculation = () => {
    const _NonSalaryTDS =
      NonSalaryTDS?.reduce((acc, curr) => {
        const value = Number(curr.TaxDeductedClaimedForThisYear);
        return acc + (isNaN(value) ? 0 : value);
      }, 0) || 0;

    setFieldValue("TotalTDSonOthThanSals", _NonSalaryTDS);
    setFieldValue("TaxesPaidTDSandTCS.NonSalaryTDS", NonSalaryTDS);
  };

  return (
    <>
      <section className="mb-5">
        <div className="section-title-wrap">
          <h5>
            TDS on Non Salary
            <small>TDS on interest income, professional or consulting income</small>
          </h5>
          <div className="btns-wrap">
            {/* <Button
							variant="primaryDark"
							size="sm"
							onClick={() => setShowUpload26ASFormCanvas(() => true)}
						>
							<FASvgIcon icon={faUpload} />
							Upload for 26AS
						</Button> */}
            <PreventEditComponent>
              <Button
                variant="secondary"
                size="sm"
                onClick={() => setShowAddFormCanvas(() => true)}
              >
                <FASvgIcon icon={faPlus} />
                Add Manually
              </Button>
            </PreventEditComponent>
          </div>
        </div>

        <dl className="eds-list eds-dl eds-inline-between">
          {NonSalaryTDS?.map((donation, index) => (
            <div key={`non-salary-${index}`} className="eds-list--item">
              <dt>{donation.DeductorName}</dt>
              <dd>
                <span>
                  <PriceDisplay price={parseInt(donation?.TaxDeductedClaimedForThisYear || "0")} />
                </span>
                <Button
                  variant="link"
                  onClick={() => {
                    setShowAddFormCanvas(() => true);
                    setActiveItem(() => donation);
                    setActiveItemIdx(() => String(index));
                  }}
                >
                  View
                  <PreventEditComponent>
                    <>/Edit</>
                  </PreventEditComponent>
                </Button>
                <Button
                  variant="transparent"
                  className="icon-only"
                  onClick={() => {
                    setShowDeleteModal(() => donation);
                    setActiveItemIdx(() => String(index));
                  }}
                >
                  <FASvgIcon icon={faTrash} />
                </Button>
              </dd>
            </div>
          ))}
        </dl>
      </section>

      <TDSNonSalaryDetailsAddManuallyForm
        showCanvas={showAddFormCanvas}
        handleCloseBtnPress={(donationData) => {
          if (donationData) {
            if (activeItem) {
              NonSalaryTDS?.splice(Number(activeItemIdx), 1, donationData);
            } else {
              NonSalaryTDS?.push(donationData);
            }
            handleTotalCalculation();
          }
          setShowAddFormCanvas(() => false);
          setActiveItem(() => null);
          setActiveItemIdx(() => "");
        }}
        formValues={activeItem}
      />

      <ConfirmationModal
        showModal={!!showDeleteModal}
        iconColorClass="text-danger"
        title="Are you sure?"
        message={<p>You want to delete {showDeleteModal?.DeductorName}</p>}
        onYesBtnClick={() => handleDeleteItem()}
        onNoBtnClick={() => setShowDeleteModal(() => null)}
        icon={faTrashAlt}
      />

      {/* <TDSNonSalaryDetailsAddManuallyForm
				showCanvas={showUpload26ASFormCanvas}
				handleCloseBtnPress={(donationData) => {
					if (donationData) {
						if (activeItem) {
							NonSalaryTDS?.splice(Number(activeItemIdx), 1, donationData);
						} else {
							NonSalaryTDS?.push(donationData);
						}
						setFieldValue(
							"TaxesPaidTDSandTCS.NonSalaryTDS",
							NonSalaryTDS
						);
					}
					setShowUpload26ASFormCanvas(() => false);
					setActiveItem(() => null);
					setActiveItemIdx(() => "");
				}}
				formValues={activeItem}
			/> */}
    </>
  );
};

export default TDSNonSalaryDetails;
